// extracted by mini-css-extract-plugin
export default {"storeBadges":"FooterContainer_storeBadges__UNvcG"};